import React from "react";
import "./FilterChip.scss"; // optional styling

interface FilterChipProps {
  label: string;
  onRemove: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove }) => {
  return (
    <div className="filter-chip">
      <button className="filter-chip-remove" onClick={onRemove}>
        ✕
      </button>
      <span className="filter-chip-label">{label}</span>
    </div>
  );
};

export default FilterChip;
